export const ElectronicBillErrors = {
  ACCESS_TOKEN: "ACCESS_TOKEN",
  NOT_FOUND: "NOT_FOUND",
  FILE_CORRUPTED: "FILE_CORRUPTED",
};
export const UserErrors = {
  EMPTY_CHECKED_PRODUCTS: "EMPTY_CHECKED_PRODUCTS",
};
